import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VueClipboard from 'vue-clipboard2'
import Vuelidate from 'vuelidate';
import {db} from  '@/fb';
import colors from 'vuetify/lib/util/colors'
import 'vue-croppa/dist/vue-croppa.css';
import Croppa from 'vue-croppa';
import money from 'v-money'
import VCurrencyField from 'v-currency-field'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Croppa);
Vue.use(Vuetify);
Vue.use(VueClipboard)
Vue.use(Vuelidate);
Vue.use(money, {precision: 2})
Vue.use(VCurrencyField, {
  locale: 'en-US',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true
})

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: colors.grey.darken2,
        secondary: colors.grey.darken1,
        accent: colors.grey.black,
        error: colors.grey.accent3,
        info: colors.grey,
        success: colors.grey,
        warning: colors.grey,
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
})
export default vuetify
